import "../stylesheets/web_components.scss"
import { BRFSearch } from "../../../engines/shared_assets/app/web_components/searchbar/search"
import { toggleNavbar } from "../../../engines/shared_assets/app/web_components/navbar/navbar"

window.BRFSearch = BRFSearch
window.toggleNavbar = toggleNavbar

const abrfScriptsLoaded = new window.CustomEvent("ABRFScriptsLoaded")
document.dispatchEvent(abrfScriptsLoaded)
